import React, { useContext, useState } from 'react';
import Link from 'atomic/link';
import Collapsible from 'react-collapsible';
import { items } from './static-page-sidebar.data';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import generateElementId from 'helpers/generate-element-id';

import './static-page-sidebar.scss';

const getIndexOfActiveTab = (dataSource: typeof items, url: string): number => {
    for (let i = 0; i < dataSource.length; i++) {
        const elements = dataSource[i].items;

        for (const [index] of elements.entries()) {
            if (elements[index].href === url) {
                return i;
            }
        }
    }

    return -1;
};

const StaticPageSidebar: React.FC = () => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const currentPath = api.getPath();
    const [id, setId] = useState<number | null>(getIndexOfActiveTab(items, currentPath));
    const triggerClick = (index: number): void => setId(index === id ? null : index);

    return (
        <div className="static-page-sidebar">
            <ul className="accordion">
                {items.map((item, index: number) => (
                    <Collapsible
                        tabIndex={index}
                        trigger={item.label}
                        handleTriggerClick={(): void => triggerClick(index)}
                        open={id === index}
                        contentElementId={`collapsible-content-${index}-${generateElementId(item.label)}`}
                        triggerElementProps={{ id: `collapsible-trigger-${index}-${generateElementId(item.label)}` }}
                        classParentString="accordion__item"
                        contentInnerClassName="accordion__item-content"
                        contentContainerTagName="li"
                        transitionTime={300}
                        key={item.label}
                    >
                        <ul>
                            {
                                item.items.map(link => (
                                    <li className={currentPath === link.href ? 'active' : ''} key={link.href}>
                                        <Link href={link.href}>
                                            {link.label}
                                        </Link>
                                    </li>
                                ))
                            }
                        </ul>
                    </Collapsible>
                ))}
            </ul>
        </div>
    );
};

export default StaticPageSidebar;
